// SSO providers
export const SOCIAL_AUTH_PROVIDERS = ['Apple', 'Facebook', 'Google', 'Microsoft'];
export const WHITE_TEXT_COLOR_PROVIDERS = ['Apple', 'Facebook'];
//# sourceMappingURL=constants.js.map